// extracted by mini-css-extract-plugin
export default {"main":"input_main__GmNMR","inputText":"input_inputText__RR-RJ","error":"input_error__CV-Pg","selectBtn":"input_selectBtn__4Pe7W"};